<app-interfix-and-hypothesis-list
  [isHypothesis]="false"
  [list]="interfixList"
  [showProgressBar]="showProgressBar"
  [routerLinkPart]="'/morphology/interfixes'"
  [errorMessageSource]="errorMessageSource"
  (deleteElementEvent)="deleteInterfix($event)"
></app-interfix-and-hypothesis-list>
